// Session-scoped tracking of products the customer has opened on the detail page.
// Used to render the "Recently Viewed" strip on the BOB Store page.

const RECENT_KEY = "bob_store_recent";
const MAX_ITEMS = 12;

export const trackProductView = (productId) => {
  if (typeof window === "undefined" || !productId) return;
  try {
    const raw = sessionStorage.getItem(RECENT_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    const list = Array.isArray(arr) ? arr.filter((id) => id !== productId) : [];
    list.unshift(productId);
    sessionStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
  } catch {
    // Ignore quota / privacy mode errors
  }
};

export const getRecentProductIds = () => {
  if (typeof window === "undefined") return [];
  try {
    const raw = sessionStorage.getItem(RECENT_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
};

export const removeProductFromRecent = (productId) => {
  if (typeof window === "undefined" || !productId) return;
  try {
    const raw = sessionStorage.getItem(RECENT_KEY);
    if (!raw) return;
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return;
    const next = arr.filter((id) => id !== productId);
    if (next.length === 0) {
      sessionStorage.removeItem(RECENT_KEY);
    } else {
      sessionStorage.setItem(RECENT_KEY, JSON.stringify(next));
    }
  } catch {
    // Ignore quota / privacy mode errors
  }
};
